

















































































































import { Component, Prop, Vue } from "vue-property-decorator";
import { IPageConfig } from "@/@types/filoxenia-config/nav-bar";

import BSwitch from "@/components/app/switchs/b-switch.vue";
import ChangeDeliteButtons from "@/components/buttons/change-delite-buttons.vue";

@Component({
  components: { BSwitch, control: ChangeDeliteButtons },
})
class RouteButtonCard extends Vue {
  @Prop({ type: Object, default: null }) item!: IPageConfig | null;
  @Prop({ type: Array, default: () => [] }) pages!: Array<IPageConfig>;

  get navigationGroup(): string {
    return this.item?.navigation?.navigationGroup || this.item?.nav || "";
  }

  get pageGroup(): string {
    return this.item?.navigation?.pageGroup || "";
  }

  get pageGroupTitle(): string {
    if (!this.pageGroup) return "—";
    const page = this.pages.find((el) => el._id === this.pageGroup);
    if (!page) return this.pageGroup;
    return page.name.ru || page.name.en || page._id;
  }

  get tvRoute(): string {
    return this.item?.params?.tv?.route || this.item?.route || "";
  }

  get tvFooter(): Array<string> {
    return this.item?.params?.tv?.footer || [];
  }

  get grid(): number {
    return this.item?.params?.tv?.variant?.grid || this.item?.grid || 1;
  }

  get variantClass(): string {
    return this.item?.params?.tv?.variant?.class || "";
  }

  get mobileRoute(): string {
    return this.item?.params?.mobile?.route || "";
  }

  get navChildren(): Array<string> {
    return this.item?.navigation?.children || this.item?.children || [];
  }

  get childrenTitles(): Array<string> {
    return this.navChildren.map((id) => {
      const page = this.pages.find((el) => el._id === id);
      return page ? page.name.ru || page.name.en || id : id;
    });
  }

  get iconView(): string {
    const icon = this.item?.src?.icon;
    if (icon && typeof icon === "object") return `${icon.icon} (${icon.lib})`;
    return typeof icon === "string" ? icon : "";
  }
}
export default RouteButtonCard;
